export const ALL_STROKE_SIDES = {
    top: true,
    right: true,
    bottom: true,
    left: true,
};
export const DEFAULT_FILL_GRADIENT = {
    angle: 180,
    colorStart: '#3b82f6',
    colorEnd: '#8b5cf6',
};
export const DEFAULT_OBJECT_SHADOW = {
    enabled: false,
    offsetX: 4,
    offsetY: 4,
    blur: 8,
    spread: 0,
    color: 'rgba(0,0,0,0.35)',
};
export const DEFAULT_OBJECT_GLOW = {
    enabled: false,
    blur: 16,
    color: '#60a5fa',
};
